import {appInstance} from '@/utils/app-accessor'

export const getCachedItems = async type => {
    const cachedItems = (await appInstance.$localForage.getItem(type))?.filter(item => item.wishlist) || []

    return cachedItems
}

export const transferFavoritesFromStorage = async userId => {
    try {
        if (!userId) return

        const promises = []
        const wishlist = await appInstance.$api.wishlist.get({userId})
        wishlist.forEach(item => (item.wishlist = true))
        const wishlistHotels = wishlist.filter(item => item.productType === 'hotel')

        if (appInstance.$conf.public.activeProducts.includes('hotels')) {
            const cachedHotels = await getCachedItems('hotelWishlist')

            cachedHotels.forEach(cachedHotel => {
                const exist = wishlistHotels.some(
                    ({supplierCode, cityCode, hotelCode}) =>
                        cachedHotel.supplierCode === supplierCode &&
                        cachedHotel.cityCode === cityCode &&
                        cachedHotel.hotelCode === hotelCode
                )
                if (!exist) {
                    const info = {
                        name: cachedHotel.name,
                        thumb: cachedHotel.thumb,
                        address: cachedHotel.address,
                        distance: cachedHotel.distance,
                        district: cachedHotel.district,
                        services: cachedHotel.services,
                        otaCodeServices: cachedHotel.otaCodeServices,
                        category: cachedHotel.category,
                        type: cachedHotel.type,
                        searchRequest: cachedHotel.searchRequest,
                        recommended: cachedHotel.recommended,
                        tariffRecommended: cachedHotel.tariffRecommended,
                    }
                    const query = {
                        supplierCode: cachedHotel.supplierCode,
                        hotelCode: cachedHotel.hotelCode,
                        cityCode: cachedHotel.cityCode,
                        productType: 'hotel',
                    }
                    promises.push(appInstance.$api.wishlist.post({userId, ...info, ...query}))
                }
            })
        }
        if (appInstance.$conf.public.activeProducts.includes('activities')) {
            const cachedActivities = await getCachedItems('activityWishlist')
            cachedActivities.forEach(cachedActivity => {
                const exist = wishlistHotels.some(({id}) => cachedActivity.id === id)

                if (!exist) {
                    const info = {
                        productType: 'activity',
                        mainImage: cachedActivity.mainImage,
                        shortDescription: cachedActivity.shortDescription,
                        info: {
                            name: cachedActivity.info.name,
                            id: cachedActivity.info.id,
                        },
                        offers: [],
                        searchRequest: cachedActivity.searchRequest,
                    }
                    const query = {id: cachedActivity.info.id, productType: 'activity'}
                    promises.push(appInstance.$api.wishlist.post({userId, ...info, ...query}))
                }
            })
        }

        await Promise.allSettled(promises)

        if (appInstance.$conf.public.activeProducts.includes('hotels'))
            appInstance.$localForage.setItem('hotelWishlist', [])
        if (appInstance.$conf.public.activeProducts.includes('activities'))
            appInstance.$localForage.setItem('activityWishlist', [])
    } catch {
        /* empty */
    }
}
